export const ROUTES = {
    landingPage:'/',
    service:'/service',
    contactUs:'/contact'
}